import { all, call, put } from 'redux-saga/effects';
import { chunk } from 'lodash-es';
import { splitFileIntoChunks, uploadInitVideoObjectSuccessAction, uploadResetAction } from 'pages/upload.page';
import { errorHandleAction } from 'components/error-handle/actions';
import { chunkUploadApi, createVideoApi } from 'common/api';
import { appRoutes } from 'routes';
import { history } from 'app.history';
import { getNewRelicAgent } from 'newRelicAgent';

/**
 * 2MB
 * @type {number}
 */
const chunkSize = 2097152; // 2MB
// const chunkSize = 104857600000; // ~100 GB
// const chunkSize = 104857600; // 100MB
// const chunkSize = 20971520; // 20MB
// const chunkSize = 10485760; // 10MB
// const chunkSize = 5242880; // 5MB
// const chunkSize = 1048576; // 1MB

/**
 * How many chunks to upload in parallel
 * @type {number}
 */
const parallelChunks = 1;

/**
 * @param {string} uploadUrl
 * @param {File} file
 */
export function* chunkFileUpload(uploadUrl, file) {
  try {
    const chunks = splitFileIntoChunks(file, chunkSize);
    const total = chunks.length;
    const chunksGroups = chunk(chunks, parallelChunks);
    let chunkNumber = 1;

    for (let i = 0; i < chunksGroups.length; i++) {
      let chunksGroup = chunksGroups[i];
      let buffer = [];
      for (let j = 0; j < chunksGroup.length; j++) {
        buffer.push(call(chunkUploadApi, uploadUrl, chunksGroup[j], chunkNumber, total));
        chunkNumber++;
      }
      yield all(buffer);
    }
  } catch (error) {
    yield put(errorHandleAction(error, error.status));
    getNewRelicAgent().noticeError(error);
  }
}

/**
 * @param {{type: Symbol, payload: {file: File}}} action initVideoUploadAction
 */
export function* uploadVideoRequestEffect(action) {
  try {
    const { file, skipSelectVideo } = action.payload;

    if (skipSelectVideo) {
      history.push(appRoutes.upload);
    }

    const newVideo = yield createVideoApi();
    yield put(
      uploadInitVideoObjectSuccessAction({
        ...newVideo,
        title: file.name.match(/^.*\./)[0].slice(0, -1),
      })
    );
    yield chunkFileUpload(newVideo.uploadUrl, file);
  } catch (error) {
    yield put(uploadResetAction());
    yield put(errorHandleAction(error, error.status));
    document.getElementById('select-file-hidden-input').value = '';
  }
}
